import Vue from 'vue'

export default Vue.extend({
  name: 'ProgressLinear',

  props: {
    value: {
      type: Number as Prop<number>,
      default: 0
    },
    color: {
      type: String as Prop<string>,
      default: '#36807A'
    },
    height: {
      type: Number as Prop<number>,
      default: 3
    }
  }
})
